export default __webpack_public_path__ + "static/poster-6bfd0f1c7bdc83a5cbb707c489d69ac9.png";